import { APP_CONFIG_KEYS_ENUM, IAppConfigServiceApis } from "./IAppConfigServiceApis"
import ApiUtils from "../ApiUtils"

const getAppConfigWithKeyUrl = (key: APP_CONFIG_KEYS_ENUM) => `/app-config-cache/get-config?configKey=${key}`

class AppConfigServiceApis implements IAppConfigServiceApis {
	getConfig = (key: APP_CONFIG_KEYS_ENUM) => {
		const url = getAppConfigWithKeyUrl(key)
		return ApiUtils.get(url)
	}
}

export default AppConfigServiceApis
